<template>
  <div class="container p-6 has-text-centered has-background-white">
    <div class="image" style="width:300px;margin: 0 auto">
      <img src="images/TC wired for Gant Travel.png" />
      <img src="/images/SVGs/Plane_with_Clouds.svg" alt="Book Travel with Trip Circuit">
    </div>

    <div style="max-width:600px;margin: 0 auto">
    <p class="is-size-4 mb-2 has-text-weight-bold">Account not authorized.</p>
    <p class="is-size-6 mb-4">This account has not been configured to allow booking through TripCircuit. Please contact your Gant Travel account administrator for further assistance. </p>
    </div>
    
    <b-button
          size="is-medium"
          type="is-gant"
          class="ubuntu"
          data-test="login_button"
          @click="$router.push('/login')"
          
        >
          <h5>Return to Login</h5>
        </b-button>
  </div>
</template>

<script>
export default {
  name: "NotAuthorized",
  props: {},
  methods: {},
};
</script>

<style scoped>
.image {
  padding: 15px;
  padding-right: 20px;
}</style>
